import React from 'react';
import {
  CardMedia,
  Card
} from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import { useImpression } from '@thd-olt-component-react/impression';
import { useQuoteContext } from '../../../hooks/useQuoteContext';
import QuotesHeader from '../QuotesHeader';
import NullViewContent from './NullViewContent';
import { nullStatePropTypes } from './nullStatePropTypes';

const DesktopNullView = ({
  imageUrl,
  imageAlt
}) => {
  const { componentId } = useQuoteContext();
  const { ref, clickID } = useImpression({
    data: {
      component: 'QuotesFallbackView',
      name: 'QuotesFallbackView',
      id: componentId,
      position: 1,
      type: 'content',
    }
  });

  return (
    <Card
      data-component="Quotes"
      data-testid="quotes-container"
      className="sui-h-full"
      orientation="horizontal"
      CardContentProps={{
        className: classNames(
          'sui-flex-col',
          'sui-flex',
          'sui-gap-4',
          'sui-p-4',
          'sui-w-full',
          'sui-grow'
        )
      }}
      ref={ref}
      clickid={clickID}
    >
      {/* eslint-disable-next-line react/no-unknown-property */}
      <div className="sui-flex sui-gap-4 sui-h-full sui-justify-between">
        <div
          className={classNames(
            'sui-flex',
            'sui-flex-col',
            'sui-gap-4',
            'sui-basis-1/2',
            'sui-min-w-64'
          )}
        >
          <QuotesHeader hideActionLink />
          <NullViewContent />
        </div>
        <div
          id="null-image"
          className="sui-max-w-md sui-basis-1/2"
        >
          <CardMedia
            src={imageUrl}
            alt={imageAlt}
            className={classNames(
              'sui-w-full',
              'sui-h-full',
              'sui-transform',
              'sui-object-cover',
              'sui-object-center'
            )}
          />
        </div>
      </div>
    </Card>
  );
};

DesktopNullView.propTypes = nullStatePropTypes;

export default DesktopNullView;
